import React from "react";
import { useTranslation } from "react-i18next";
import PaymentFrequency from "src/components/CustomizePayment/PaymentFields/PaymentFrequency";
import Miles from "src/components/CustomizePayment/PaymentFields/Sliders/Miles";
import useSelector from "src/utils/useSelector";
import CalculatorRow from "../../CalculatorRow";
import DownPayment from "../Sliders/DownPayment";
import Term from "../Sliders/Term";

const LeaseFields = ({ vin }: { vin: string }) => {
    const { t } = useTranslation();

    const downPaymentLabel = useSelector((state) => state.account.account_disclaimers.down_payment_label_lease);
    const region = useSelector((state) => state.account.address?.country);

    return (
        <div className="LeaseFields__container">
            <CalculatorRow
                title={t("CustomizePayment.PaymentFields.LeaseFields.term")}
                className="CalculatorRow__slider"
            >
                <Term paymentType={"lease"} vin={vin} />
            </CalculatorRow>
            <PaymentFrequency paymentType={"lease"} vin={vin} />
            <CalculatorRow
                title={
                    region === "CA"
                        ? t("CustomizePayment.PaymentFields.LeaseFields.annualKilometers")
                        : t("CustomizePayment.PaymentFields.LeaseFields.annualMiles")
                }
                className="CalculatorRow__slider"
            >
                <Miles vin={vin} />
            </CalculatorRow>
            <CalculatorRow
                title={downPaymentLabel ?? t("CustomizePayment.PaymentFields.LeaseFields.downPayment")}
                className="CalculatorRow__slider"
            >
                <DownPayment paymentType={"lease"} vin={vin} />
            </CalculatorRow>
        </div>
    );
};

export default LeaseFields;
